import { render, staticRenderFns } from "./IntangibleLocation.vue?vue&type=template&id=f227ddf0&"
import script from "./IntangibleLocation.vue?vue&type=script&lang=js&"
export * from "./IntangibleLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports